import { render, staticRenderFns } from "./MultipleLookups.vue?vue&type=template&id=4dbafac3&scoped=true&"
import script from "./MultipleLookups.vue?vue&type=script&lang=js&"
export * from "./MultipleLookups.vue?vue&type=script&lang=js&"
import style0 from "./MultipleLookups.vue?vue&type=style&index=0&id=4dbafac3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbafac3",
  null
  
)

export default component.exports